module.exports = __webpack_public_path__ + "img/missile-pod.f30f5ad3.svg";